import { atom } from 'jotai';

/**
 * True while the active asset listing on the current page has its
 * infinite-scroll mode engaged and more results remain — i.e. the user has
 * clicked "Show more" (or the listing auto-enables infinite scroll on mount)
 * and the query still has pages to fetch.
 *
 * Consumed by:
 *   - `AppContainer` to gate the site-wide `<Footer />` — hidden while more
 *     results are loading, revealed again at the true end of the results.
 *   - `ContributorPage` to gate the `FeaturedInSection` render.
 *
 * Each listing is responsible for setting this to `true` when it enters
 * infinite mode, resetting it to `false` once the final page has loaded
 * (`hasNextPage` is false), and clearing it on unmount / on filter change.
 * Pages without an infinite-scrolling listing must not touch it.
 */
export const listingInfiniteScrollActiveAtom = atom(false);
